var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "78.767%",
    cy: "50%",
    fx: "78.767%",
    fy: "50%",
    r: "50%",
    id: "coins_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DB05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB502",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "url(#coins_svg__a)",
    stroke: "#2E2E32",
    strokeWidth: 2,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.914,
    cy: 14.914,
    r: 14.914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.371,
    cy: 14.914,
    r: 14.914
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgNDAgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Q29pbnMgQ29weTwvdGl0bGU+CiAgICA8ZGVmcz4KICAgICAgICA8cmFkaWFsR3JhZGllbnQgY3g9Ijc4Ljc2NjkxMzklIiBjeT0iNTAlIiBmeD0iNzguNzY2OTEzOSUiIGZ5PSI1MCUiIHI9IjUwJSIgaWQ9InJhZGlhbEdyYWRpZW50LTEiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRjhEQjA1IiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNFRUI1MDIiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgICAgIDwvcmFkaWFsR3JhZGllbnQ+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iRGVzaWduLVBhZ2VzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR0EtTGFuZGluZy1Ob24tTG9naW4iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDQ2LjAwMDAwMCwgLTI3Mi4wMDAwMDApIiBmaWxsPSJ1cmwoI3JhZGlhbEdyYWRpZW50LTEpIiBzdHJva2U9IiMyRTJFMzIiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJTaWduLVVwLUZvcm0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgwNi4wMDAwMDAsIDE4Ny4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJDb2lucy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDEuMDAwMDAwLCA4Ni4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQ29pbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMTQuOTEzNjA3NyIgY3k9IjE0LjkxMzYwNzciIHI9IjE0LjkxMzYwNzciPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMjIuMzcxMDA1OCIgY3k9IjE0LjkxMzYwNzciIHI9IjE0LjkxMzYwNzciPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgCoins as ReactComponent };